module.exports = __webpack_public_path__ + "img/cup_pt_hex_setsku.prt.bfa2e824.jpg";